import React, { Component } from 'react'
import classnames from 'classnames'
import Product from './Product'
import { emptyObject } from '@/constant'
import { BaseComponentItemPropsType } from '@/typings/types'
import styles from './index.module.less'
import { px2rem } from '@/utils/styleUtils'

if (typeof window !== 'undefined') {
  require('@/utils/img-lazy-load')
}

interface IProps extends BaseComponentItemPropsType<any> {
  getRef?: (p: any) => void
}

class ProductFlow extends Component<IProps> {
  calcTabItemStyle = () => {
    const { propsConfig, globalConfig } = this.props
    if (!propsConfig || !globalConfig) {
      return emptyObject
    }
    const { style = {} } = globalConfig
    const {
      tabItemPaddingLeft = 15,
      tabItemPaddingRight = 15,
      tabItemPaddingTop = 1,
      tabItemPaddingBottom = 30,
      tabItemContentBg,
    } = propsConfig
    return {
      paddingTop: tabItemPaddingTop ? px2rem(tabItemPaddingTop) : 1,
      paddingLeft: px2rem(tabItemPaddingLeft),
      paddingRight: px2rem(tabItemPaddingRight),
      paddingBottom: px2rem(tabItemPaddingBottom),
      background: tabItemContentBg || style.background,
    }
  }

  render() {
    const { propsConfig, pageId, globalConfig, editConfig, getRef } = this.props
    if (!propsConfig) return ''
    const {
      tabItemTitle: groupName,
      tabTextColorActive: tabBarActiveTextColor,
      tabItemTitleBg,
      contentMarginTop = 0,
      // source = 0,
      // tabList = [],
      // categoryList = [],
      // bidList = [],
    } = propsConfig

    // const dataSource = {
    //   0: tabList,
    //   1: categoryList,
    //   2: bidList,
    // }
    // const ProductContainer = components[source]
    const newProps = {
      groupName,
      editConfig,
      tabBarActiveTextColor,
      globalConfig,
      pageId,
      tabItemTitleBg,
    }

    const productBoxStyle = {
      marginTop: px2rem(-contentMarginTop),
    }

    return (
      <div
        className={classnames({
          [styles['poizon-new-production-flow']]: true,
        })}
        ref={getRef}
      >
        <div style={this.calcTabItemStyle()} className={styles['product-view-box-wrapper']}>
          {
            <div style={productBoxStyle} className={`_product_item_0_ productViewBox`}>
              <Product {...newProps} />
            </div>
          }
        </div>
      </div>
    )
  }
}

export default ProductFlow
